export const typesDocuments = [
  {
    value: 'residence_permit',
    label: 'ВНЖ(Вид на жительство)',
  },
  {
    value: 'visa',
    label: 'Виза',
  },
  {
    value: 'migration_card',
    label: 'Миграционная карта',
  },
  {
    value: 'temporary_residence_permit',
    label: 'РВП (разрешение на временное пребывание)',
  },
  {
    value: 'patent',
    label: 'Патент',
  },
  {
    value: 'work_permit',
    label: 'РНР (разрешение на работу)',
  },
  {
    value: 'employment_contract',
    label: 'Трудовой договор',
  },
];

export const visaTypes = [
  { value: 'physical_visa', label: 'Физическая виза' },
  { value: 'e_visa', label: 'Электронная виза' },
];

export const textareaStyles = {
  input: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '12px',
    paddingBottom: '12px',
    fontSize: '16px',
    border: 'none',
  },
};

export const selectStyles = {
  input: {
    height: 48,
    fontSize: '16px',
    border: 'none',
    padding: '0 16px',
    cursor: 'pointer',
  },
  option: {
    minHeight: '48px',
    height: 'auto',
    fontSize: '16px',
    padding: '12px 16px',
    lineHeight: '1.4',
    whiteSpace: 'normal' as const,
    wordWrap: 'break-word' as const,
  },
  dropdown: {
    boxShadow: '0px 0px 10px 0px rgba(0, 32, 51, 0.10)',
    border: 'none',
    borderRadius: 4,
    padding: 0,
    zIndex: 100001,
  },
  section: {
    marginRight: '6px',
  },
};

export const dateInputStyles = {
  root: { width: '100%' },
  wrapper: { width: '100%' },
  input: {
    width: '100%',
    height: '48px',
    fontSize: '16px',
    border: 'none',
  },
};
